import { colors } from 'shared/styles/colors'
import styled from 'styled-components'

export const Text = styled.p`
  font-weight: 400;
  font-size: 14px;
  color: ${colors.gray7};
`
export const Title = styled.h3`
  font-weight: 600;
  font-size: 16px;
  color: ${colors.primary};
`
